"use client";

import { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/16/solid";

interface TabDropdownProps {
    tabs: string[];
    selectedTab: string;
    onTabChange: (tab: string) => void;
}

export default function TabDropdown({
    tabs,
    selectedTab,
    onTabChange,
}: TabDropdownProps) {
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleSelect = (tab: string) => {
        onTabChange(tab);
        setDropdownOpen(false);
    };

    return (
        <div className="relative w-full lg:hidden">
            <button
                onClick={() => setDropdownOpen((prev) => !prev)}
                className="w-full flex items-center justify-between px-6 py-2 font-medium text-white bg-purple border border-purple rounded-full capitalize"
            >
                <span>{selectedTab}</span>
                <ChevronDownIcon
                    className={`w-6 h-6 transition-transform duration-150 ${
                        dropdownOpen ? "rotate-180" : "rotate-0"
                    }`}
                />
            </button>

            <div
                className={`absolute left-0 right-0 top-full mt-2 z-10 bg-[#E4CEF8] border border-purple rounded-3xl overflow-hidden transition-all duration-150 ${
                    dropdownOpen
                        ? "opacity-100 pointer-events-auto"
                        : "opacity-0 pointer-events-none"
                }`}
            >
                {tabs.map((tab, index) => (
                    <button
                        key={index}
                        onClick={() => handleSelect(tab)}
                        className="w-full px-6 py-3 text-center text-purple font-medium transition-colors capitalize"
                    >
                        {tab}
                    </button>
                ))}
            </div>
        </div>
    );
}
